<script lang="ts">
	import { appState } from '$lib/appstate.svelte';
	import { MAIN_TABS } from '$lib/constants';
	import { onMount } from 'svelte';
	import FeedbackForm from '$lib/components/FeedbackForm.svelte';

	onMount(() => {
		appState.mainTab = MAIN_TABS.ABOUT;
	});
</script>

<section class="mx-auto flex w-full max-w-3xl flex-col gap-8 px-6 py-20">
	<h1 class="text-4xl font-bold">About this website</h1>

	<p class="text-lg leading-relaxed">
		This website shows French verb conjugations and has AI generated English definitions and usage.
	</p>

	<p class="text-lg leading-relaxed">If you have any feedback on this site, enter it below.</p>

	<FeedbackForm verb="" category="main" />
</section>
